import { Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import LoginForm from '../components/templates/LoginForm'


const useStyles = makeStyles((theme) => ({
    login_screen: {
        backgroundImage:"url('https://source.unsplash.com/1600x900/?nature,water')",
        minHeight:"100vh",
        backgroundSize:"cover",
        backgroundRepeat:"no-repeat"
    },
  }));


const LoginScreen = () => {
    const classes = useStyles();

    return (
        <Grid container className={classes.login_screen} >
            <LoginForm/>
        </Grid>
    )
}

export default LoginScreen
